import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';

export const serviceContractsApiSlice = createApi({
  reducerPath: 'serviceContractsApiSlice',
  tagTypes: ['ServiceContract'],
  baseQuery,
  endpoints: (builder) => ({
    getServiceContract: builder.query({
      query: ({ apiManager }) => apiManager.get(),
      providesTags: ['ServiceContract'],
    }),
    saveServiceContract: builder.mutation({
      query: ({ apiManager, data }) => apiManager.save(data),
      invalidatesTags: (_, error) => (error ? [] : ['ServiceContract']),
    }),
    // Stages the wizard's in-progress values into `service_contracts.pending_changes`
    // between steps (deferred — nothing is applied to the contract until it is
    // signed). Deliberately does NOT invalidate the ServiceContract tag: the flow
    // keeps its own in-memory Form as the source of truth, so a refetch mid-wizard
    // would only risk clobbering unsaved edits.
    partialUpdateServiceContract: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.partialUpdate(id, data),
      invalidatesTags: (_, error) => (error ? [] : ['ServiceContract']),
    }),
    switchToAnnual: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.switchToAnnual(id, data),
      invalidatesTags: (_, error) => (error ? [] : ['ServiceContract']),
    }),
    // Generates the contract preview PDF (blob) from the passed params WITHOUT
    // persisting them — the params are only committed later on init-sign. Kept as
    // a query (not a mutation) so the preview step can `refetch()` it on demand.
    previewServiceContract: builder.query({
      query: ({ apiManager, id, data }) => apiManager.preview(id, data),
      providesTags: ['ServiceContract'],
    }),
  }),
});

export const {
  useGetServiceContractQuery,
  useLazyGetServiceContractQuery,
  useSaveServiceContractMutation,
  usePartialUpdateServiceContractMutation,
  useSwitchToAnnualMutation,
  usePreviewServiceContractQuery,
  useLazyPreviewServiceContractQuery,
} = serviceContractsApiSlice;
